import { SECOND_IN_MS } from '@/config/magic-values';

export default {
  DURATION: {
    SHORT: 5 * SECOND_IN_MS,
    MEDIUM: 12 * SECOND_IN_MS,
    LONG: 25 * SECOND_IN_MS,
    FOREVER: 0,
  },
};



// WEBPACK FOOTER //
// ./src/config/notify-constants.js